import { gql } from '@apollo/client';

export default gql`
  mutation updateProStar($procId: String) {
    updateProStar(procId: $procId) {
      ok
      message
      data
      error
    }
  }
`;
